<template>
  <div class="row boxes-row">
    <div class="col-lg-6"  v-for="file in files" :key="file.idFile">
      <CompanyFileBox :box="file"/>
    </div>
  </div>
</template>

<script>
import CompanyFileBox from "@/components/files/CompanyFileBox";
export default {
name: "CompanyFilesGrid",
  props: ['files'],
  components: {CompanyFileBox}
}
</script>

<style scoped>

</style>